import React, { useCallback } from "react";
import { SelectedEquipmentForReportStyled } from "../../theme";
import { PointDetail } from "./pointDetail";

export const SelectedEquipment = ({ item, Remove }) => {
  const removeReportClickHandler = useCallback(
    (point) => {
      Remove && Remove(item.route, point);
    },
    [item, Remove]
  );
  return (
    <SelectedEquipmentForReportStyled>
      <div className="title">{item.route.name}</div>
      {item.points.length > 0 &&
        item.points.map((item, index) => {
          return (
            <PointDetail
              key={index}
              point={item}
              Remove={removeReportClickHandler}
            />
          );
        })}
    </SelectedEquipmentForReportStyled>
  );
};
